import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams, RowNode } from "ag-grid-community";
import { Observer } from "rxjs";

interface CellParams extends ICellRendererParams {
  toggleLocked: Observer<RowNode>;
}
@Component({
  selector: "fr-lock-row-renderer",
  templateUrl: "./html/bfx-lock-row-renderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LockRowRenderer implements ICellRendererAngularComp {
  private params: CellParams;
  public locked: boolean = false;
  public forwardFirstOrder: boolean = false;
  public selectable: boolean = false;
  previous: { locked: boolean; forwardFirstOrder: boolean; selectable: boolean };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = {
      locked: this.locked,
      forwardFirstOrder: this.forwardFirstOrder,
      selectable: this.selectable,
    };
  }

  agInit(params: CellParams): void {
    this.updateParams(params);
  }

  private updateParams(params: CellParams): boolean {
    this.params = params;

    this.previous.selectable = this.selectable;
    this.previous.locked = this.locked;
    this.previous.forwardFirstOrder = this.forwardFirstOrder;

    this.selectable = params.data?.supportsSelection === true;
    this.locked = params.data?.lockedForUserPricing === true;
    this.forwardFirstOrder = params.data?.forwardFirstOrder === true;

    return (
      this.selectable !== this.previous.selectable ||
      this.locked !== this.previous.locked ||
      this.forwardFirstOrder !== this.previous.forwardFirstOrder
    );
  }

  refresh(params?: CellParams): boolean {
    if (this.updateParams(params)) {
      this.cd.markForCheck();
    }

    return true;
  }

  /**
   * Clicking on the icon sends out an event on the toggleLocked Observer
   * @param _event
   */
  onMouseDown(_event: MouseEvent) {
    if (this.params?.context?.toggleLocked) {
      this.params.context.toggleLocked.next(this.params.node);
    }
  }
}
